import { useCallback } from 'react'

import { GetExportJobDownloadResponseDto } from '~shared/types/export-job.dto'

import { ApiService } from '~lib/helpers/api'

export function useExportJobDownload(campaignId: string) {
  const downloadExportJob = useCallback(
    async (jobId: string) => {
      const { data } = await ApiService.get<GetExportJobDownloadResponseDto>(
        `/campaigns/${campaignId}/distributions/exports/${jobId}/download`,
      )

      const fileLink = document.createElement('a')
      fileLink.href = data.download_url
      fileLink.download = ''
      fileLink.click()
    },
    [campaignId],
  )

  return { downloadExportJob }
}
